import React from "react";
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonItem,
  IonLabel,
  IonIcon,
  IonBadge,
  IonList,
  IonText,
  IonButtons,
  IonBackButton,
} from "@ionic/react";
import {
  rocketOutline,
  syncOutline,
  addCircleOutline,
  lockClosedOutline,
  bulbOutline,
  bookOutline,
  carOutline,
  cartOutline,
} from "ionicons/icons";
import "./CommunityFAQ.css";

const CommunityFAQ = () => {
  return (
    <IonPage className="community-faq">
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonBackButton
              defaultHref="/trending"
              mode="ios"
              text=""
              className="transparent-back-button"
            />
          </IonButtons>
          <IonTitle className="poetsen">How Communities Work</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent className="community-container">
        <div className="content-wrapper">
          {/* Header Section */}
          <section className="intro-section">
            <IonIcon icon={rocketOutline} className="header-icon" />
            <h1 className="main-title poetsen">How Communities Work</h1>
            <p className="subtitle">
              Communities are created in two ways — automatically or manually
            </p>
          </section>

          {/* Automatic Communities */}
          <IonCard className="feature-card auto-card">
            <IonCardHeader>
              <div className="card-header-flex">
                <IonIcon icon={syncOutline} color="secondary" />
                <IonCardTitle>
                  <IonCardTitle>
                    Automatic Communities (Recommended)
                  </IonCardTitle>
                </IonCardTitle>
              </div>
            </IonCardHeader>
            <IonCardContent>
              <p className="description">
                Communities are auto-created when you post from key features:
              </p>

              <IonList lines="none" className="feature-list">
                <IonItem>
                  <div>
                    <div className="feature-list-top">
                      <IonIcon icon={bookOutline} slot="start" />
                      <h3>Study</h3>
                    </div>
                    <IonLabel>
                      <p>
                        Share a quiz or exam → related community created (e.g.,
                        grade9science, nclex-rn)
                      </p>
                    </IonLabel>
                  </div>
                </IonItem>
                <IonItem>
                  <div>
                    <div className="feature-list-top">
                      <IonIcon icon={carOutline} slot="start" />
                      <h3>Ride</h3>
                    </div>
                    <IonLabel>
                      <p>
                        Post a ride → a local ride community is created for that
                        area
                      </p>
                    </IonLabel>
                  </div>
                </IonItem>
                <IonItem>
                  <div>
                    <div className="feature-list-top">
                      <IonIcon icon={cartOutline} slot="start" />
                      <h3>Local Finds</h3>
                    </div>
                    <IonLabel>
                      <p>
                        Post an item → a local market community is created
                        automatically
                      </p>
                    </IonLabel>
                  </div>
                </IonItem>
              </IonList>
              <div className="info-box">
                <p>
                  👉 You don’t need to name or set anything — it just works.
                </p>
              </div>
            </IonCardContent>
          </IonCard>

          {/* Manual Creation */}
          <IonCard className="feature-card manual-card">
            <IonCardHeader>
              <div className="card-header-flex">
                <IonIcon icon={addCircleOutline} color="tertiary" />
                <IonCardTitle>Create Manually</IonCardTitle>
              </div>
            </IonCardHeader>
            <IonCardContent>
              {/* <IonList lines="full">
                <IonItem>
                  <IonLabel>Tap ➕ Create Community</IonLabel>
                </IonItem>
                <IonItem>
                  <IonLabel>Enter a Community Name & Description</IonLabel>
                </IonItem>
                <IonItem>
                  <IonLabel>Upload a Logo & Choose Privacy</IonLabel>
                </IonItem>
              </IonList> */}
              <ol className="feature-card-list">
                <li>Tap ➕ Create Community</li>
                <li>Enter a Community Name & Description</li>
                <li>Upload a Logo & Choose Privacy</li>
              </ol>
              <div className="perfect-for">
                <strong>Perfect for:</strong> Custom study groups, professional
                circles, and private teams.
              </div>
            </IonCardContent>
          </IonCard>

          {/* Privacy & Info */}
          <div className="footer-grid">
            <div className="footer-item">
              <h3>
                <IonIcon icon={lockClosedOutline} /> Privacy
              </h3>
              <p>
                Private communities are invite-only. You control what you post
                and share.
              </p>
            </div>
            <div className="footer-item">
              <h3>
                <IonIcon icon={bulbOutline} /> Good to Know
              </h3>
              <p>
                No duplicates—everything stays organized in one Community hub.
              </p>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default CommunityFAQ;
